/*
  Main App component with routing for FullStack.cash
*/

import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import PrivateRoute from './components/auth/PrivateRoute'

// Pages
import HomePage from './pages/HomePage'
import Pricing from './pages/Pricing'
import Examples from './pages/Examples'
import Documentation from './pages/Documentation'
import Consulting from './pages/Consulting'
import Portfolio from './pages/Portfolio'
import Login from './pages/Login'
import Profile from './pages/Profile'
import Contact from './pages/Contact'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import FrontEnd from './pages/FrontEnd'
import BackEnd from './pages/BackEnd'
import Libraries from './pages/Libraries'
import CashStrap from './pages/CashStrap'
import Faucet from './pages/Faucet'
import FreeAccess from './pages/FreeAccess'
import ExploreABC from './pages/ExploreABC'
import ExploreBCHN from './pages/ExploreBCHN'
import ExploreTestnet from './pages/ExploreTestnet'
import Example from './pages/Example'
import NotFound from './pages/NotFound'
import Apis from './pages/Apis'
import CashBox from './pages/CashBox'

function App () {
  return (
    <Routes>
      <Route path='/' element={<Layout><HomePage /></Layout>} />
      <Route path='/pricing' element={<Layout><Pricing /></Layout>} />
      <Route path='/examples' element={<Layout><Examples /></Layout>} />
      <Route path='/documentation' element={<Layout><Documentation /></Layout>} />
      <Route path='/consulting' element={<Layout><Consulting /></Layout>} />
      <Route path='/portfolio' element={<Layout><Portfolio /></Layout>} />
      <Route path='/login' element={<Layout><Login /></Layout>} />
      <Route
        path='/profile'
        element={
          <PrivateRoute>
            <Layout><Profile /></Layout>
          </PrivateRoute>
        }
      />
      <Route path='/contact' element={<Layout><Contact /></Layout>} />
      <Route path='/blog' element={<Layout><Blog /></Layout>} />
      <Route path='/blog/:slug' element={<Layout><BlogPost /></Layout>} />
      <Route path='/front-end' element={<Layout><FrontEnd /></Layout>} />
      <Route path='/back-end' element={<Layout><BackEnd /></Layout>} />
      <Route path='/libraries' element={<Layout><Libraries /></Layout>} />
      <Route path='/cashstrap' element={<Layout><CashStrap /></Layout>} />
      <Route path='/faucet' element={<Layout><Faucet /></Layout>} />
      <Route path='/free-access' element={<Layout><FreeAccess /></Layout>} />
      <Route path='/explore-abc' element={<Layout><ExploreABC /></Layout>} />
      <Route path='/explore-bchn' element={<Layout><ExploreBCHN /></Layout>} />
      <Route path='/explore-testnet' element={<Layout><ExploreTestnet /></Layout>} />
      <Route path='/example' element={<Layout><Example /></Layout>} />
      <Route path='/apis' element={<Layout><Apis /></Layout>} />
      <Route path='/cash-box' element={<Layout><CashBox /></Layout>} />
      <Route path='*' element={<Layout><NotFound /></Layout>} />
    </Routes>
  )
}

export default App
